import { Extension } from '@tiptap/core';
import Suggestion from '@tiptap/suggestion';
import { PluginKey } from 'prosemirror-state';
import InternalLinkSuggestionCommands from '../InternalLinkSuggestionCommands';

export const InternalLinkSuggestionPluginKey = new PluginKey('internalLinkSuggestion');

export const InternalLinkSuggestionExtension = Extension.create({
  name: 'internalLinkSuggestion',

  addProseMirrorPlugins() {
    return [
      Suggestion({
        pluginKey: InternalLinkSuggestionPluginKey,
        editor: this.editor,
        char: '[[',
        command: ({ editor, range, props }) => {
          // This command will be called when an item is selected from the suggestion list
          // For internal links, we'll replace the `[[query]]` with the actual link node.
          editor.chain().focus().deleteRange(range).setInternalLink(props.id, props.title).run();
        },
        items: InternalLinkSuggestionCommands.items,
        render: InternalLinkSuggestionCommands.render,
      }),
    ];
  },
});
